import { useState } from "react";
import { alpha } from "@mui/material/styles";
import { Box, Typography, SpeedDial, SpeedDialAction, SpeedDialIcon, Backdrop, Menu, MenuItem, ListItemIcon } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import CheckIcon from "@mui/icons-material/Check";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import CodeRoundedIcon from "@mui/icons-material/CodeRounded";
import { Database } from "@zesty-io/material";
import { useHistory, useLocation } from "react-router";
import { CreateContentItemDialog } from "../../../../shell/components/CreateContentItemDialog";
interface Props {
  dateRange: number;
  onDateRangeChange: (dateRange: number) => void;
}
const dateRanges = [7, 14, 30, 90];
export const Header = ({
  dateRange,
  onDateRangeChange
}: Props) => {
  const {
    t
  } = useTranslation();
  const userFirstName = useSelector((state: any) => state.user.firstName);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [open, setOpen] = useState(false);
  const [openCreateContentDialog, setOpenCreateContentDialog] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const actions = [{
    icon: <EditRoundedIcon />,
    name: t("dashboard.createContent"),
    onClick: () => setOpenCreateContentDialog(true)
  }, {
    icon: <ImageRoundedIcon />,
    name: t("dashboard.uploadMedia"),
    onClick: () => history.push("/media?triggerUpload=true", {
      from: location.pathname
    })
  }, {
    icon: <Database />,
    name: t("dashboard.createModel"),
    onClick: () => history.push("/schema?triggerCreate=true")
  }, {
    icon: <CodeRoundedIcon />,
    name: t("dashboard.createCodeFile"),
    onClick: () => history.push("/code?triggerCreate=true")
  }];
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return <>
      <Box sx={{
      height: "160px",
      color: "common.white",
      px: 3,
      py: 2,
      background: theme => `linear-gradient(91.57deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
    }} data-sentry-element="Box" data-sentry-source-file="Header.tsx">
        <Typography variant="h4" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="Header.tsx">
          {t("dashboard.greeting", {
          name: userFirstName
        })}
        </Typography>
        <Typography variant="subtitle1" marginTop={0.5} data-cy="dashboardInstanceSummary" data-sentry-element="Typography" data-sentry-source-file="Header.tsx">
          {t("dashboard.instanceSummary")}{" "}
          <Box component="span" onClick={handleClick} sx={{
          gap: 0.25,
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          textDecoration: "underline"
        }} data-sentry-element="Box" data-sentry-source-file="Header.tsx">
            {t("dashboard.lastNDaysInline", {
            count: dateRange
          })}{" "}
            <KeyboardArrowDownRoundedIcon data-sentry-element="KeyboardArrowDownRoundedIcon" data-sentry-source-file="Header.tsx" />
          </Box>
        </Typography>
      </Box>
      <Menu open={openMenu} onClose={handleClose} anchorEl={anchorEl} data-sentry-element="Menu" data-sentry-source-file="Header.tsx">
        {dateRanges.map(dateRangeItem => <MenuItem key={dateRangeItem} onClick={() => {
        onDateRangeChange(dateRangeItem);
        handleClose();
      }} sx={{
        ...(dateRangeItem === dateRange && {
          backgroundColor: theme => alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        })
      }}>
            <ListItemIcon sx={{
          visibility: dateRangeItem !== dateRange && "hidden"
        }}>
              <CheckIcon color="primary" />
            </ListItemIcon>
            {t("dashboard.lastNDays", {
          count: dateRangeItem
        })}
          </MenuItem>)}
      </Menu>
      <Backdrop onClick={() => setOpen(false)} open={open} sx={{
      zIndex: theme => theme.zIndex.speedDial - 1
    }} data-sentry-element="Backdrop" data-sentry-source-file="Header.tsx" />
      <SpeedDial ariaLabel={t("dashboard.speedDialAriaLabel")} sx={{
      position: "absolute",
      top: 16,
      right: 24
    }} icon={<SpeedDialIcon />} open={open} onClick={() => setOpen(!open)} direction="down" FabProps={{
      size: "small",
      sx: {
        backgroundColor: "#fff !important",
        boxShadow: "none",
        color: "primary.main"
      }
    }} data-sentry-element="SpeedDial" data-sentry-source-file="Header.tsx">
        {actions.map(action => <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} FabProps={{
        sx: {
          backgroundColor: "primary.main",
          color: "common.white",
          "&:hover": {
            backgroundColor: "primary.dark"
          }
        }
      }} onClick={action.onClick} tooltipOpen />)}
      </SpeedDial>
      {openCreateContentDialog ? <CreateContentItemDialog open={openCreateContentDialog} onClose={() => setOpenCreateContentDialog(false)} /> : null}
    </>;
};